/**
 * What the mat should show for what the player is holding: a tray's markers
 * being placed, the twelve being arranged, the starting tiles being put down.
 * The pointer's part — which tray it is over, which marker it is dragging —
 * comes in beside, because it is the screen's business and not the game's.
 */
import type { TrajanTile, View } from '@trajan/engine';
import type { MatInteraction } from '../mat/matShow';
import { START_SLOTS } from '../setup/tilePlan';
import type { Holding } from './holding';

export function matFor(
  view: View,
  holding: Holding,
  pointer: { hover?: number | null; dragging?: number | null } = {},
): MatInteraction {
  const tileOn = (stack: number): TrajanTile | null => view.board.trajanStacks[stack]?.[0] ?? null;
  const placed: Record<number, TrajanTile> = {};
  if (holding.kind === 'tiles') {
    for (const [slot, stack] of Object.entries(holding.plan.placed)) {
      const tile = tileOn(stack);
      if (tile) placed[Number(slot)] = tile;
    }
  }
  return {
    placing: holding.kind === 'tray' ? { tray: holding.tray, order: holding.order } : null,
    arranging: holding.kind === 'arrange' ? holding.layout : null,
    held: holding.kind === 'tray' || holding.kind === 'arrange' ? holding.held : null,
    dragging: pointer.dragging ?? null,
    hover: pointer.hover ?? null,
    tiles:
      holding.kind === 'tiles'
        ? {
            slots: START_SLOTS,
            placed,
            holding: holding.plan.holding === null ? null : tileOn(holding.plan.holding),
          }
        : null,
  };
}
